export default __webpack_public_path__ + "static/media/sec_con.87597b6b.svg";